import { defineAsyncComponent } from 'vue'

const asyncComponents = {
    CalendarView: defineAsyncComponent(() => import('@/views/hub/components/layout/HistoryCalendar.vue')),
    Columns: defineAsyncComponent(() => import('@/views/hub/components/layout/Columns.vue')),
    Counters: defineAsyncComponent(() => import('@/views/hub/components/summary/details/Counters.vue')),
    Description: defineAsyncComponent(() => import('@/views/hub/components/summary/details/Description.vue')),
    Events: defineAsyncComponent(() => import('@/views/hub/components/Events.vue')),
    GroupBlocks: defineAsyncComponent(() => import('@/views/hub/components/summary/details/groupBlocks/Component.vue')),
    GroupGridBlocks: defineAsyncComponent(() => import('@/views/hub/components/summary/details/groupGridBlocks/Component.vue')),
    EventsList: defineAsyncComponent(() => import('@/views/hub/components/events/EventsList.vue')),
    ListView: defineAsyncComponent(() => import('@/views/hub/components/history/List.vue')),
    Metrics: defineAsyncComponent(() => import('@/views/hub/components/history/Metrics.vue')),
    NoEventsBox: defineAsyncComponent(() => import('@/views/hub/components/events/NoEventsBox.vue')),
    Notifications: defineAsyncComponent(() => import('@/views/hub/components/events/Notifications.vue')),
    NowView: defineAsyncComponent(() => import('@/views/hub/components/now/NowView.vue')),
    Rows: defineAsyncComponent(() => import('@/views/hub/components/layout/Rows.vue')),
    Statuses: defineAsyncComponent(() => import('@/views/hub/components/summary/details/Statuses.vue')),
    Tabs: defineAsyncComponent(() => import('@/views/hub/components/layout/Tabs.vue')),
    Uptime: defineAsyncComponent(() => import('@/views/hub/components/history/Uptime.vue'))
}

export function getComponent (componentName) {
    return asyncComponents[componentName]
}
